import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { ClienteIntermedio } from "@interfaces/user.interface";

interface Props {
  data: ClienteIntermedio;
}

export function DetalleClienteIntermedio({ data }: Props) {
  const { nombreEmpresa, creadoEl, actualizadoEl, usuario } = data;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Información del Cliente</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <strong>Empresa:</strong> {nombreEmpresa}
        </div>
        <div>
          <strong>Creado el:</strong> {new Date(creadoEl).toLocaleDateString()}
        </div>
        <div>
          <strong>Actualizado el:</strong>{" "}
          {new Date(actualizadoEl).toLocaleDateString()}
        </div>

        <div className="border-t pt-4">
          <strong>Usuario Responsable:</strong>
          <div className="mt-2 space-y-1 ml-2">
            <div>
              <strong>Nombre:</strong> {usuario.nombre}{" "}
              {usuario.apellidoPaterno} {usuario.apellidoMaterno ?? ""}
            </div>
            <div>
              <strong>Correo:</strong> {usuario.correo}
            </div>
            <div>
              <strong>Rol:</strong> {usuario.rol?.nombre}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
